class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('recently-viewed-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initSwipeHide();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  initSwipeHide() {
    if (!document.getElementById('swipe-hide-css')) {
      const style = document.createElement('style');
      style.id = 'swipe-hide-css';
      style.textContent = `.product-grid.slider.swipe-used li:first-child::after,
        .product-grid.slider.swipe-used li:first-child:after {
          display: none; opacity: 0; content: none; visibility: hidden;
        }`;
      document.head.appendChild(style);
    }

    const slider = this.querySelector('.product-grid.slider');
    if (!slider) return;

    const key = 'swipe-used-' + slider.id;

    if (sessionStorage.getItem(key)) {
      slider.classList.add('swipe-used');
      return;
    }

    let startX, startY, triggered = false;

    slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (triggered) return;
      const dx = Math.abs(e.touches[0].clientX - startX);
      const dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 25 && dx > dy * 1.2) {
        triggered = true;
        slider.classList.add('swipe-used');
        sessionStorage.setItem(key, 'true');
      }
    }, { passive: true });
  }

  getQueryString() {
    const cookieName = 'beyours:recently-viewed';
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items.map((item) => "id:" + item).slice(0, 4).join(" OR ");
  }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);